<template>
  <!--header-->
  <header id="header">
    <div class="mainheader">
      <div class="side-left">
        <div class="logo">
          <a
            href="https://www.appedu.com.tw/"
            target="_blank"
            class="home-icon"
            title="赫綵設計學院"
            >赫綵設計學院</a
          >
        </div>
      </div>
      <div class="side-right mainheader-right">
        <a href="#1" class="">搶先卡位</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  mounted() {
    $(".nft-qa li a").click(function () {
      let target = this.hash,
        $target = $(target).offset().top;

      $("html, body").animate({ scrollTop: $target }), 1500;
    });

    $(".s6-btn a").click(function () {
      let target = this.hash,
        $target = $(target).offset().top;

      $("html, body").animate({ scrollTop: $target }), 1500;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/reset.scss";

// * ==========================================================================
// * HEADER 區塊
// * ==========================================================================

#header {
  width: 100%;
  padding: 15px 16px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: $color-primary-2;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);

  @include min-width(768px) {
    padding: 18px 20px;
  }

  @include min-width(1025px) {
    padding: 18px 60px;
  }

  @include min-width(1440px) {
    padding: 18px 120px;
  }
}

.mainheader {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  transition: 0.2s;

  @include min-width(1440px) {
    width: 1200px;
  }

  @include min-width(1920px) {
    width: 1400px;
  }
}

// * ==========================================================================
// *  LOGO
// * ==========================================================================

.logo {
  width: 120px;
  height: 24px;
  display: block;
  margin-left: 5px;
  position: relative;

  @include min-width(768px) {
    width: 150px;
    height: 50px;
  }

  @include min-width(1025px) {
    width: 187px;
    height: 40px;
    margin-left: 0px;
  }

  > a {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    color: $color-white;
    background: url("@/assets/images/Header/Logo_Normal.svg") no-repeat
      center/contain;
    @include hidetext;
    transition: 0.2s;

    @include min-width(1025px) {
      &:hover {
        background: url("@/assets/images/Header/Logo_Hover.svg") no-repeat
          center/contain;
      }
    }
  }
}

.mainheader-right {
  > a {
    display: block;
    padding: 4px 12px;
    color: $color-primary-2;
    font-size: 16px;
    background: linear-gradient(270deg, #bbd293 0%, #ffd79a 100%);
    box-shadow: 0px 2px 10px #f0e7c8;
    border-radius: 5px;
    transition: 0.2s;

    @include min-width(768px) {
      font-size: 18px;
    }

    @include min-width(1025px) {
      &:hover {
        box-shadow: none;
        background: linear-gradient(270deg, #bbd293 0%, #c8c0b4 100%);
      }
    }
  }
}
</style>